class CollapsibleTab extends HTMLElement {
  constructor() {
    super();
    this.contentHeight = 0;
    this.content = this.querySelector('.collapsible-content');
    this.trigger = this.querySelector('.collapsible-trigger');
    this.icon = this.querySelector('.collapsible-icon');
    this.trigger.addEventListener('click', this.toggle.bind(this));
    window.addEventListener('resize', () => {
      if(this.contentHeight > 0) {
        this.calcHeight();
        this.content.style.height = `${this.contentHeight}px`;
      }
    });
  }

  connectedCallback() {
    if(this.hasAttribute('data-open')) {
      this.open();
    }
  }

  calcHeight() {
    const clone = this.content.cloneNode(true);
    Object.assign(clone.style, {
      overflow: 'visible',
      height: 'auto',
      maxHeight: 'none',
      opacity: '0',
      visibility: 'hidden',
      display: 'block'
    });
    this.content.after(clone);
    this.contentHeight = clone.offsetHeight + 10;
    clone.remove();
  }

  toggle() {
    this.contentHeight === 0 ? this.open() : this.close();
  }

  open() {
    this.calcHeight();
    this.content.style.height = `${this.contentHeight}px`;
    this.icon.innerHTML = '-';
  }

  close() {
    this.content.style.height = '0px';
    this.contentHeight = 0;
    this.icon.innerHTML = '+';
  }
}

if (!customElements.get('collapsible-tab')) {
  customElements.define('collapsible-tab', CollapsibleTab);
}